import { render, staticRenderFns } from "./InfoReview.vue?vue&type=template&id=72b21314"
import script from "./InfoReview.vue?vue&type=script&lang=js"
export * from "./InfoReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports